import React from 'react';

const ToggleSwitch = ({ label, isOn, id = 'toggle', onChange }) => {
  const handleToggle = e => {
    if (onChange) {
      onChange(e.target.checked); // Notify parent component of the updated state
    }
  };

  return (
    <div className="toggle-container">
      {label && <label className="toggle-label">{label}</label>}
      <div className="toggle-switch">
        <input
          type="checkbox"
          id={id}
          className="toggle-input"
          checked={isOn}
          onChange={handleToggle}
        />
        <label htmlFor={id} className="toggle-slider"></label>
      </div>
    </div>
  );
};

export default ToggleSwitch;
